import {RadioGroup, TextInput} from "omoplay";
import React, {useEffect, useState} from "react";


const RouletteButtonGenerateForm = ({onPrompt}) => {
    const [buttonForm, setButtonForm] = useState({
        outside: "#D4AD7B",
        color: "#DCCCB1",
        textColor: "#333333",
        name: "START"
    })

    useEffect(() => {
        onPrompt(`룰렛 게임의 시작 버튼을 벡터 기반의 일러스트레이터 스타일로 그려주세요.
                전체적으로는 배경은 투명하고 중심에는 ${buttonForm.outside}색 원이 ${buttonForm.color}색 원을 감싼 배치된 구성이고, 아이콘처럼 단순하고 명확하게 보여야 합니다.
                원 안에는 '${buttonForm.name}'라는 텍스트가 정중앙에 위치해 있고, 글씨는 굵은 산세리프체로 써주세요.
                색상은 ${buttonForm.outside} 원 배경, ${buttonForm.color} 중심 원, ${buttonForm.textColor} 텍스트를 사용하고, 테두리, 그림자는 없이 깔끔하게, 입체감 없이 평면적인 벡터 스타일로 표현해주세요.`
        )
    }, [buttonForm])

    return (
        <div className="flex-col gap-4">
            <div className="text-[20px] font-semibold">템플릿을 선택 하세요</div>
            <RadioGroup items={[
                { label: (<img alt="preview_coupon"
                               src="https://img.headless.co.kr/offline_qr_service/7/61c98c14-f413-47bb-a5a9-a32afca1e922"
                               width="100px" />
                    ), value: "black"}
            ]} onSelected={(items) => console.log(items)} />
            <div className="text-[20px] font-semibold">색상</div>
            <div className="flex-align-center gap-4">
                글자색: <input type="color" value={buttonForm.textColor}
                            onChange={(e) => setButtonForm((prev) => {
                                return { ...prev, textColor: e.target.value}
                            })} />
                바깥색: <input type="color" value={buttonForm.outside}
                           onChange={(e) => setButtonForm((prev) => {
                               return { ...prev, outside: e.target.value}
                           })} />
                안쪽색: <input type="color" value={buttonForm.color}
                            onChange={(e) => setButtonForm((prev) => {
                                return { ...prev, color: e.target.value}
                            })} />
            </div>
            <div className="text-[20px] font-semibold">버튼명</div>
            <TextInput value={buttonForm.name}
                       onChange={(e) => setButtonForm((prev) => {
                           return { ...prev, name: e.target.value}
                       })}
            />
        </div>
    )
}

export default RouletteButtonGenerateForm